import { SupportedLangCode, useLocaleState } from '@alice-financial/alice-sdk'
import { Button, Select } from '@alice-financial/pretext-ui'
import LanguageIcon from '@mui/icons-material/Language'
import * as React from 'react'

type SwitchLanguageProps = {
  compact?: boolean
}

const CompactLanguageSwitch = () => {
  const [locale, setLocale, disabled] = useLocaleState()
  return (
    <Select
      onChange={(e) => setLocale(e.target.value as SupportedLangCode)}
      value={locale}
      disabled={disabled}
      aria-label="Switch language"
    >
      <option value="en-us">English</option>
      <option value="es">Español</option>
    </Select>
  )
}

export const SwitchLanguage = ({ compact }: SwitchLanguageProps) => {
  const [locale, setLocale, disabled] = useLocaleState()
  if (compact) return <CompactLanguageSwitch />

  return (
    <Button
      size="small"
      color="inherit"
      disabled={disabled}
      onClick={() => setLocale(locale === 'en-us' ? 'es' : 'en-us')}
      endIcon={<LanguageIcon />}
    >
      {locale === 'en-us' ? '¿Prefieres español?' : 'Prefer English?'}
    </Button>
  )
}
